/**
 * Light/dark mode. "system" follows the OS. public/theme-init.js stamps <html data-theme> before
 * the first paint (prerendered pages paint before this module loads); this keeps it in step.
 */
export type ThemeChoice = 'system' | 'light' | 'dark'
const KEY = 'codex-theme'

export function getThemeChoice(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'dark' ? v : 'system'
  } catch {
    return 'system'
  }
}

function resolve(choice: ThemeChoice): 'light' | 'dark' {
  if (choice !== 'system') return choice
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}

export function applyTheme(choice: ThemeChoice = getThemeChoice()): void {
  document.documentElement.dataset.theme = resolve(choice)
}

export function setThemeChoice(choice: ThemeChoice): void {
  try {
    if (choice === 'system') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, choice)
  } catch {
    // Private mode: the choice lasts for this page only.
  }
  applyTheme(choice)
}

applyTheme()
window.matchMedia?.('(prefers-color-scheme: light)').addEventListener?.('change', () => applyTheme())
